import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-os',
  templateUrl: './os.component.html',
  styleUrls: ['./os.component.scss'],
  providers: [CommonService]
})
export class OsComponent implements OnInit {
  public os:any;
  public obras:any[];

  constructor(private commonService:CommonService) { }

  ngOnInit() {
    this.os = {
      nombre: '',
      precio: 0,
      federacion: false,
      documentacion: ''
    };

    this.commonService.getOS()
      .then(result => this.obras = result);
  }

  public saveOS() {
    if (this.os.federacion) {
      this.os.federacion = 1;
    } else {
      this.os.federacion = 0;
    }

    this.commonService
      .saveOS(this.os)
      .then(() => {
        this.os = {
          nombre: '',
          precio: 0,
          federacion: 0,
          documentacion: ''
        };

        this.commonService.getOS()
          .then(result => this.obras = result);
    });
  }
}



// WEBPACK FOOTER //
// /Users/tretapey/Documents/Programmer/craCSS/DOC-in/src/app/carga/os/os.component.ts